export default __webpack_public_path__ + "static/media/TicTacToe.640ae837.gif";